import withResource from '../withResource'
import { selectLoginTokenData } from './selectors'

/**
 * wraps component with user data
 *
 * @param {Object} options - options to pass withResource
 * @return {Function} hoc function to wrap component with user data
 * @see withResource
 */
export default options => withResource({
  resourceSelector: selectLoginTokenData,
  resourceProp: 'user',
  displayName: 'withUser',
  ...options
})
